import axios, { AxiosError } from 'axios';

import { DEFAULT_ERROR_MESSAGE } from '@app/constants';
import type { NServices } from '@app/types/Services';

import type { AxiosResponse } from 'axios';

export const createServerRequestFile: NServices.CreateServerRequest = async (
  axiosConfig
) => {
  try {
    const response: AxiosResponse<NServices.ApiResult, typeof axiosConfig> =
      await axios(axiosConfig);
    const isServerError = !response.data.Success;
    const { ErrorMessage } = response.data;

    if (isServerError) {
      throw ErrorMessage || DEFAULT_ERROR_MESSAGE;
    }

    return response.data;
  } catch (error) {
    const isAxiosError = error instanceof AxiosError && error?.message;
    const isServerError = typeof error === 'string';

    if (isAxiosError) {
      throw new Error(error?.message || '');
    }

    if (isServerError) {
      throw new Error(error);
    }

    throw new Error(JSON.stringify(error));
  }
};
